import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { CalculationHistory } from '@/components/CalculationHistory';
import { SavedCalculations } from '@/components/premium/SavedCalculations';
import { useCalculationHistory } from '@/hooks/useCalculationHistory';
import { usePremium } from '@/hooks/usePremium';

export const BasicPercentage: React.FC = () => {
  const [percentage, setPercentage] = useState<string>('');
  const [value, setValue] = useState<string>('');
  const [result, setResult] = useState<number | null>(null);
  const { history, favorites, addCalculation, toggleFavorite, clearHistory } = useCalculationHistory();
  const { isPremium } = usePremium();

  const calculate = () => {
    const percent = parseFloat(percentage);
    const val = parseFloat(value);
    
    if (!isNaN(percent) && !isNaN(val)) {
      const calculatedResult = (percent / 100) * val;
      setResult(calculatedResult);
      
      // Add to history
      addCalculation(
        'basic',
        { percentage: percent, value: val },
        calculatedResult.toFixed(2)
      );
    }
  };

  return (
    <Card className="shadow-card">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-card-foreground">
          What is X% of Y?
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="percentage" className="text-sm font-medium">
              Percentage (X)
            </Label>
            <Input
              id="percentage"
              type="number"
              placeholder="Enter percentage"
              value={percentage}
              onChange={(e) => setPercentage(e.target.value)}
              className="h-12"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="value" className="text-sm font-medium">
              Value (Y)
            </Label>
            <Input
              id="value"
              type="number"
              placeholder="Enter value"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className="h-12"
            />
          </div>
        </div>
        
        <Button 
          onClick={calculate}
          className="w-full h-12 bg-calculator-gradient hover:opacity-90 transition-opacity"
        >
          Calculate
        </Button>
        
        {result !== null && (
          <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg shadow-result">
            <p className="text-sm text-muted-foreground mb-1">Result:</p>
            <p className="text-2xl font-bold text-primary">
              {result.toFixed(2)}
            </p>
          </div>
        )}
        
        {isPremium && result !== null && (
          <SavedCalculations
            type="basic"
            inputs={{ percentage: parseFloat(percentage), value: parseFloat(value) }}
            result={result.toFixed(2)}
          />
        )}
        
        <CalculationHistory
          history={history.filter(item => item.type === 'basic')}
          favorites={favorites}
          onToggleFavorite={toggleFavorite}
          onClearHistory={clearHistory}
        />
      </CardContent>
    </Card>
  );
};